/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Heading_MarketingInputs */

const ja_work_heading_marketing = /** @type {(inputs: Work_Heading_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game Culture Marketing`)
};

const en_work_heading_marketing = /** @type {(inputs: Work_Heading_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game Culture Marketing`)
};

/**
* | output |
* | --- |
* | "Game Culture Marketing" |
*
* @param {Work_Heading_MarketingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const work_heading_marketing = /** @type {((inputs?: Work_Heading_MarketingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Heading_MarketingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_work_heading_marketing(inputs)
	return en_work_heading_marketing(inputs)
});